module.exports = __webpack_public_path__ + "static/media/right-button-off.76cbc699.png";